import { render, staticRenderFns } from "./HandToHand.vue?vue&type=template&id=b094146a&"
import script from "./HandToHand.vue?vue&type=script&lang=ts&"
export * from "./HandToHand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports